import { useState } from "react"

import { Alert, Badge, Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import SelectComponent from "../../../../Components/Select"
import Icon from "../../../../Icon"
import {
  alertStatusColorMap,
  alertStatusTextMap,
  attentionResolveOptions
} from "../../utils/alertStatusMapping"

import "./BulkChangeAlertStatusModal.less"

const { Text } = Typography

const BulkChangeAlertStatusModal = ({ open, onClose, selectedCount, submitting, onSubmit }) => {
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const [newStatus, setNewStatus] = useState(null)

  const options = attentionResolveOptions.map((status) => ({
    value: status,
    label: (
      <Flex align="center" gap={8}>
        <Badge color={alertStatusColorMap[status] || alertStatusColorMap.default} />
        <Text strong>{t(alertStatusTextMap[status] || status)}</Text>
      </Flex>
    )
  }))

  const handleCancel = () => {
    if (submitting) return
    onClose()
  }

  const handleChangeStatus = () => {
    if (!newStatus) return
    onSubmit(newStatus)
  }

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
      width={442}
      centered={!isMobile}
      className="bulk-status-modal"
      closeIcon={<Icon type="cross_small" />}
      afterClose={() => setNewStatus(null)}
      classNames={{ content: "clear-bg" }}
      title={
        <Flex vertical gap={4}>
          <Text strong style={{ fontSize: 16 }}>
            {t("Bulk change alert status")}
          </Text>
          <Text type="secondary" style={{ fontWeight: 400 }}>
            {t("Change selected alerts from Attention to a new status.")}
          </Text>
        </Flex>
      }
    >
      <Flex vertical gap={24} style={{ marginTop: 20 }}>
        <Flex vertical gap={8}>
          <Text strong>{t("New status")}</Text>
          <SelectComponent
            style={{ width: "100%" }}
            placeholder={t("Select new status for selected alerts")}
            options={options}
            value={newStatus}
            onChange={setNewStatus}
            listHeight={isMobile ? 180 : 256}
          />
        </Flex>

        {newStatus && (
          <Alert
            type="warning"
            showIcon
            message={t(
              "Are you sure you want to change _count_ selected alerts from Attention to _status_? This action can’t be undone.",
              { count: selectedCount, status: t(alertStatusTextMap[newStatus] || newStatus) }
            )}
          />
        )}

        <Flex justify="flex-end" gap={12}>
          <ButtonComponent onClick={handleCancel} disabled={submitting}>
            {t("Cancel")}
          </ButtonComponent>
          <ButtonComponent
            type="primary"
            disabled={!newStatus}
            loading={submitting}
            onClick={handleChangeStatus}
          >
            {t("Change status")}
          </ButtonComponent>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default BulkChangeAlertStatusModal
